import {Base64} from 'js-base64';

/**
 * Obtener las ACLs decodificadas.
 *
 * @returns {{roles: *[], permisos: *[]}|any}
 * @author Jhon García
 */
export function getAcls() {
    let permisos = localStorage.getItem('acl');

    if (permisos === null) {
        return {
            roles: [],
            permisos: []
        };
    }

    let acl = Base64.decode(permisos);
    return JSON.parse(acl);
}

/**
 * Validar permiso.
 *
 * @param permiso Contiene el permiso a validar.
 * @returns {Promise<boolean>} Contiene la resolución de una promesa con un booleano.
 * @author Jhon García
 */
export function validarPermiso(permiso) {

    return new Promise((resolve, reject) => {
        try {
            const acls = getAcls();
            resolve(!!acls.permisos.find((p) => p === permiso));
        } catch (e) {
            reject();
        }
    });
}

/**
 * Validar rol.
 *
 * @param permiso Contiene el rol a validar.
 * @returns {Promise<boolean>} Contiene la resolución de una promesa con un booleano.
 * @author Jhon García
 */
export function validarRol(rol) {

    return new Promise((resolve, reject) => {
        try {
            const acls = getAcls();

            resolve(!!acls.rol === rol);
        } catch (e) {
            reject();
        }
    });
}


